export const MAP_CLASS = {
    RIDE: 'RIDE',
    SEARCH: 'SEARCH',
    BUILD: 'BUILD',
    EXPLORE: 'EXPLORE',
    PLAN: 'PLAN'
};

export const MAP_MODULES = {
    TOOLBAR: 'TOOLBAR',
    RIDE_MARKERS: 'RIDE_MARKERS',
    RIDE_TRACK: 'RIDE_TRACK',
    RIDE_POIS: 'RIDE_POIS',
    RIDE_STORE: 'RIDE_STORE',
    RIDE_SHARE: 'RIDE_SHARE',
    COMPUTE_ROAD: 'COMPUTE_ROAD',
    DRAW_LINE: 'DRAW_LINE',
    FREEHAND: 'FREEHAND',
    ELEVATION_COMPUTATION: 'ELEVATION_COMPUTATION',
    GRAPH: 'GRAPH',
    MARKER_VISIBILITY: 'MARKER_VISIBILITY',
    GEOLOCATION: 'GEOLOCATION',
    ISOCHRONE: 'ISOCHRONE',
    COLLABORATIVE: 'COLLABORATIVE'
};

export const ZOOM_SEARCH_LIMIT = 50;
